import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "modal__container modal__container--free-column"
}

import SingleSelectInput from '@/corePagesModule/SelectInput/SingleSelectInput.vue';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import MultiTagInput from '@/corePagesModule/components/MultiTagInput.vue';
import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import AddOptionSection from './AddOptionSection.vue';
import { useUpdateBusinessModalStore } from '../useUpdateBusinessModalStore';
import { storeToRefs } from 'pinia';
import { keyMappingForSelectInput, formOptionsBusiness, inputTypeKeyMap } from '../constants';
import { BusinessFreeColumnValue, IBusiness } from '@/coreDomainsModule/entities/businessBase';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { objectDiff } from '@/utils/objectDiff';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';
import { UpdateBusinessViewModel } from '../UpdateBusinessViewModel';
import { useUpdateBaseBusinessForm } from '../composables/useUpdateBaseBusinessForm';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateBaseBusinessModal',
  props: {
    item: { default: undefined }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const updateBusinessVM = new UpdateBusinessViewModel();
const store = useUpdateBusinessModalStore();
const { state } = storeToRefs(store);
const { getAddableOptions } = store;

const props = __props;

const emits = __emit;

const {
  fieldState,
  allValidate,
  isEdited,
  addNewOption,
  updateValue,
  updateUserValue,
  initializeForm,
  createUpdatedBaseBusiness,
  currentOpenSelectInputName,
} = useUpdateBaseBusinessForm();

const settingRepository = new SettingRepository();
const baseFreeColumnSettings = ref<Omit<BusinessFreeColumnValue, 'value'>[]>([]);
const businessFreeColumnValues = ref<BusinessFreeColumnValue[]>([]);

/**
 * 自由欄設定（関連取引）を取得し、設定済みの項目だけを保持する。columnNo は 1 から採番する。
 */
const fetchBaseFreeColumnSettings = async () => {
  const result = await settingRepository.getBusinessFreeColumnSetting();
  if (result.status.type !== 'success') {
    baseFreeColumnSettings.value = [];
    return;
  }
  baseFreeColumnSettings.value = result.status.data.base
    .map((item, index) => ({
      columnNo: index + 1,
      headerName: item.headerName,
      isMulti: item.isMulti,
      isConfigured: item.isConfigured ?? false,
      target: 'base' as const,
    }))
    .filter((item) => item.isConfigured);
};

/**
 * 自由欄の入力欄を編集対象の現在値でプリフィルする
 */
const initializeBusinessFreeColumns = () => {
  const stateValues = state.value.item?.businessFreeColumnValues;
  const sourceValues = stateValues?.some((column) => column.target === 'base') ? stateValues : props.item?.businessFreeColumnValues;
  businessFreeColumnValues.value = baseFreeColumnSettings.value.map((setting) => ({
    ...setting,
    value:
      sourceValues?.find((column) => (column.target === 'base' || column.target === undefined) && column.columnNo === setting.columnNo)
        ?.value ?? '',
  }));
};

/**
 * 自由欄の入力値を更新する
 * @param index - 自由欄配列のindex
 * @param value - 入力値
 */
const updateBusinessFreeColumnValue = (index: number, value: string) => {
  const target = businessFreeColumnValues.value[index];
  if (!target) return;
  target.value = value;
  isEdited.value = true;
};

const baseFreeColumnSettingsReady = fetchBaseFreeColumnSettings();

/**
 * 編集モーダルの保存ボタン押下時の処理
 */
const editingModalOnNext = async () => {
  if (!allValidate()) return;
  const updatedItem = createUpdatedBaseBusiness(props.item);
  updatedItem.businessFreeColumnValues = businessFreeColumnValues.value.map((column) => ({ ...column }));
  const updatedDiff = objectDiff(props.item ?? {}, updatedItem);
  state.value.updatedItemDiff = updatedDiff.first;

  state.value.item = updatedItem;
  emits('close', 'baseBusinessEdit', true);
};

/**
 * 自由入力カラムの編集状態を変更する
 */
const markBusinessFreeColumnEdited = () => {
  isEdited.value = true;
};

/**
 * モーダルを開いた際の処理
 */
watch(
  () => [state.value.modalState.baseBusinessEdit, state.value.isCreateMode],
  async ([stateNewVal, isCreateModeNewBal]) => {
    if (stateNewVal && !isCreateModeNewBal && props.item) {
      await baseFreeColumnSettingsReady;
      if (!state.value.modalState.baseBusinessEdit || state.value.isCreateMode) return;
      initializeForm(props.item, state.value.item);
      initializeBusinessFreeColumns();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).modalState.baseBusinessEdit && !_unref(state).isCreateMode,
    "modal-width": 1300,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('保存'),
    "is-disabled-next-button": !_unref(isEdited),
    onOnBack: _cache[0] || (_cache[0] = 
      () => {
        emits('close', 'baseBusinessEdit', false);
      }
    ),
    onOnNext: editingModalOnNext
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('選択済の取引ファイルに対して、項目の内容を修正できます。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formOptionsBusiness), (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option,
            class: "modal__item"
          }, [
            (_unref(inputTypeKeyMap)[option] === 'selectUser')
              ? (_openBlock(), _createBlock(MultipleUserSelectInput, {
                  key: 0,
                  "select-input-index": index,
                  label: _unref(t)(option),
                  placeholder: _unref(t)(option),
                  "original-selected-user-id-list": _unref(fieldState)[option].value.value ? _unref(fieldState)[option].value.value.split(',') : [],
                  "onUpdate:modelValue": (e) => _unref(updateUserValue)(option, e)
                }, null, 8, ["select-input-index", "label", "placeholder", "original-selected-user-id-list", "onUpdate:modelValue"]))
              : (_unref(inputTypeKeyMap)[option] === 'select')
                ? (_openBlock(), _createBlock(SingleSelectInput, {
                    key: 1,
                    index: index,
                    label: _unref(t)(option) + _unref(updateBusinessVM).getRequiredMark(option),
                    "model-value": _unref(fieldState)[option].value.value,
                    placeholder: _unref(t)(option),
                    "filter-type": _unref(keyMappingForSelectInput)[option],
                    "is-error": _unref(fieldState)[option]?.isError.value,
                    "error-message": _unref(fieldState)[option]?.errorMessage.value,
                    "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                    "onUpdate:modelValue": (e) => _unref(updateValue)(option, e)
                  }, null, 8, ["index", "label", "model-value", "placeholder", "filter-type", "is-error", "error-message", "onClick:selectInput", "onUpdate:modelValue"]))
                : (_openBlock(), _createBlock(TextInput, {
                    key: 2,
                    "model-value": _unref(fieldState)[option].value.value,
                    label: _unref(t)(option) + _unref(updateBusinessVM).getRequiredMark(option),
                    placeholder: _unref(t)(option),
                    "is-error": _unref(fieldState)[option].isError.value,
                    "error-message": _unref(t)(_unref(fieldState)[option].errorMessage.value),
                    "ensure-error-msg-height": "",
                    "onUpdate:modelValue": (e) => _unref(updateValue)(option, e)
                  }, null, 8, ["model-value", "label", "placeholder", "is-error", "error-message", "onUpdate:modelValue"]))
          ]))
        }), 128))
      ]),
      (businessFreeColumnValues.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessFreeColumnValues.value, (freeColumn, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: freeColumn.columnNo,
                class: "modal__item"
              }, [
                (freeColumn.isMulti)
                  ? (_openBlock(), _createBlock(MultiTagInput, {
                      key: 0,
                      "model-value": freeColumn.value,
                      label: freeColumn.headerName,
                      placeholder: freeColumn.headerName,
                      onEditing: markBusinessFreeColumnEdited,
                      "onUpdate:modelValue": (e) => updateBusinessFreeColumnValue(index, e)
                    }, null, 8, ["model-value", "label", "placeholder", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(TextInput, {
                      key: 1,
                      "model-value": freeColumn.value,
                      label: freeColumn.headerName,
                      placeholder: freeColumn.headerName,
                      "ensure-error-msg-height": "",
                      "onUpdate:modelValue": (e) => updateBusinessFreeColumnValue(index, e)
                    }, null, 8, ["model-value", "label", "placeholder", "onUpdate:modelValue"]))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(AddOptionSection, {
        "is-aggregate-business": false,
        options: _unref(getAddableOptions)(false),
        onSetOption: _unref(addNewOption)
      }, null, 8, ["options", "onSetOption"])
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})